import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { tvoedSalaryCalculatorRoutes } from '@metallgehalt/tvoed-salary-calculator';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(tvoedSalaryCalculatorRoutes)],
  exports: [RouterModule]
})
export class TvoedSalaryRoutingModule {}
